import {css} from '@emotion/react'

export const cssInfoList = {
	root: css`
		font-size: small;
		width: 100%;
	`,
	date: css`
		min-width: 75px;
		vertical-align: top;
	`,
	msg: css`
		white-space: pre-wrap;
		padding-bottom: 8px;
	`,
}